// @flow
import { CHANGE_GROCERY_LIST_VIEW_TYPE } from "./actionTypes";

export default (viewTypeName: String) => ({
  type: CHANGE_GROCERY_LIST_VIEW_TYPE,
  payload: {
    viewTypeName
  }
});